import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { RiderProfileLayoutContextInterface } from "./RiderProfileLayout";
import { useLoading } from "../../Context/LoadingProvider";
import {patrollerService} from "../../Api/Services/PatrollerService";
import redCheckIcon from "../../Assets/gfx/icons/red-x.png";
import warningIcon from "../../Assets/gfx/icons/warning.png";
import {useUser} from "../../Context/UserProvider";
import {ProfileType} from "../../Api/Models/rider.model";
import Police from "../../Assets/gfx/icons/vehicles/police.png";
import FullTime from "../../Assets/gfx/icons/8666609_user_icon.png";
import Car from "../../Assets/gfx/icons/vehicles/car.png";
import Motor from "../../Assets/gfx/icons/vehicles/motorcycle.png";
import profilePlaceholder from "../../Assets/gfx/profile.png";

interface CheckHistoryProps {
}

const CheckHistory: React.FunctionComponent<CheckHistoryProps> = () => {
  const { t } = useTranslation();
  const { startLoading, finnishLoading } = useLoading();
  const {
    setSubTitle,
    rider,
      setShowProfileInfo
  } = useOutletContext<RiderProfileLayoutContextInterface>();

  const [history, setHistory] = useState<any[]>([]);

  setShowProfileInfo(false);
  const fetchHistory = () => {
    console.log("Fetching history for rider ID:", rider?.riderId); // Log a rider ID-t
    startLoading("get-history");
    patrollerService
        .listHistory(rider.riderId)
        .then((historyItems) => {
          console.log("History items received:", historyItems); // Log a kapott history elemeket
          setHistory(historyItems);
        })
        .finally(() => {
          finnishLoading("get-history");
        });
  };


  const [displayAlreadyChecked, setDisplayAlreadyChecked] = useState(false);
  const [lastCheckDoneBy, setLastCheckDoneBy] = useState("");
  const {user} = useUser();

  const getVehicleImage = () => {
    if (rider.vehicle === 3) {
      return Car;
    }

    if (rider.vehicle === 2) {
      return Motor;
    }
  };

  useEffect(() => {
    patrollerService.latestCheckDate(rider.riderId).then(({date, name}) => {
    });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    fetchHistory();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setSubTitle();
  }, [t, setSubTitle]);

  useEffect(() => {
    patrollerService.isRiderReadyForCheck(rider.riderId).then(() => {
    }).catch((result) => {
      setLastCheckDoneBy(result.patrollerId ?? "");
      setDisplayAlreadyChecked(true);
    });
    console.log(rider);
  }, [rider]);

  setSubTitle(t('T-Patroller Actions History'));

  const laravelDateTimeToDMY = (laravelDateTime: string) => {
    var parts = laravelDateTime.split(' ');
    var datePart = parts[0];

    var dateParts = datePart.split('-');
    var year = dateParts[0];
    var month = dateParts[1];
    var day = dateParts[2];

    return day + '-' + month + '-' + year;
  }

  return (
      <>
        <div className="flex flex-col items-center">
          <div className="rider-avatar mb-2">
            <img src={rider.image ? rider.image : profilePlaceholder} alt=""/>
          </div>
        </div>
          <div className="gap-4px nav-card flex-col mb-4 background-transparent-white">
            <p className="text-small">
              {t("Rider ID")}: {rider.riderId}
              {rider.vehicle && (
                  <img
                      src={getVehicleImage()}
                      width="30px"
                      alt="Vehicle"
                      style={{display: "inline", marginLeft: "10px"}}
                  />
              )}
            </p>
            <span className="font-bold font-14 text-center">
        {rider.name}

              {rider.profileType === ProfileType.TPATROLLER && (
                  <img
                      src={Police}
                      width="25px"
                      alt="Police"
                      style={{display: "inline", marginLeft: "5px"}}
                  />
              )}
              {rider.profileType === ProfileType.FULL_TIME && (
                  <img
                      src={FullTime}
                      width="25px"
                      alt="Police"
                      style={{display: "inline", marginLeft: "5px"}}
                  />
              )}
      </span>
          </div>
          <div className="gap-4px nav-card mb-4 gears">
            {displayAlreadyChecked && user && (
                <>
                  <div className="card card-opacity flex-col items-center justify-center flex mb-1">
                    <img src={warningIcon} alt=""/>
                    <div className="font-bold text-center">
                      {user.id === lastCheckDoneBy
                          ? t(
                              "You already checked this rider in the past 3 days. Please look for a new Rider!"
                          )
                          : t(
                              "This rider was already checked within one day by another T-patroller. Please look for a new Rider!"
                          )}
                    </div>
                  </div>
                  <div className="flex flex-col justify-center items-center card">
                    {history.map((historyItem, index) => (
                        <div
                            key={index}
                            className="flex justify-between mb-4"
                            style={{width: "100%"}}
                        >
                          <div style={{width: "15%"}}>
                            <img src={redCheckIcon} alt="" style={{width: "22px"}}/>
                          </div>
                          <div style={{width: "85%"}}>
                            <p className="font-bold mb-1" style={{fontSize: "14px"}}>
                              {historyItem.message}
                            </p>
                            <p className="text-small">
                    <span className="text-orange">
                      {laravelDateTimeToDMY(historyItem.created_at)}
                    </span>
                              <span className="text-blue ml-1">
                      {t("By")} {historyItem.patroller_name}
                    </span>
                            </p>
                          </div>
                        </div>
                    ))}

                  </div>
                </>
            )}
          </div>
        </>
        );

        };

        export default CheckHistory;
